import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getPresetSubTotalPrice } from 'utils/preset.util';
import { CartSidebar } from 'panda-ui/components/CartSidebar';

import './index.scss';
import { priceDecimalFormatter } from 'formatter/preset.formatter';

const OrderBasket = ({
  onCheckoutClick,
  buttonWrap,
  totalPrice,
  totalItems,
  preset,
  deliveryPriceCents,
  checkoutData,
  removeCheckoutItem,
  setCurrentPresetItemFromCheckoutData,
  receivingMethod,
  showAddondata,
}) => {
  const { deliveryFeeData } = preset || { deliveryFeeData: { ranges: [] } };
  const [isOpened, setIsOpened] = useState(false);
  const subTotal = getPresetSubTotalPrice(checkoutData);
  const percentValue = priceDecimalFormatter(subTotal * preset.taxRate) * 100;
  const totalPriceCents = showAddondata
    ? subTotal + percentValue
    : receivingMethod === 'delivery'
    ? (subTotal + deliveryPriceCents) * (1 + preset.taxRate)
    : subTotal * (1 + preset.taxRate);
  const tooltipData = deliveryFeeData?.ranges?.join('\n') || '';

  const mappedItems = (checkoutData || []).map(item => ({
    id: item.id,
    menuItemId: item.menuId,
    name: item.name,
    quantity: item.quantity || 0,
    price: (item.priceCents || 0) / 100,
    image: '/panda_avatar.jpg',
    instructions: item.specialInstruction || '',
    options: [],
  }));

  return (
    <div className="home--form order-bk__wrapper p-0">
      <button
        type="button"
        className={`order-bk__toggler ${isOpened ? 'active' : ''}`}
        onClick={() => setIsOpened(!isOpened)}
      >
        <span className="order-bk__toggler-inner">
          <div className="order-bk__toggler-info">
            <h4>
              Total $
              {priceDecimalFormatter(
                !checkoutData || checkoutData.length === 0
                  ? 0
                  : totalPrice || totalPriceCents,
              )}
            </h4>
            <span>{totalItems} Items</span>
          </div>
          <img
            src="/assets/img/select-caret.svg"
            className="d-block order-bk-caret"
          />
          <div className="btn-wrap">
            {buttonWrap || (
              <button
                className="btn btn-primary"
                onClick={e => {
                  e.stopPropagation();
                  onCheckoutClick();
                }}
                type="button"
              >
                {showAddondata ? 'Submit Addon Order' : ' Checkout'}
              </button>
            )}
          </div>
        </span>
      </button>

      {isOpened && (
        <CartSidebar
          items={mappedItems}
          onUpdateQuantity={() => {}}
          onRemoveItem={removeCheckoutItem}
          onCheckout={onCheckoutClick}
          appliedPromo=""
          onApplyPromo={() => false}
          discountAmount={0}
          deliveryFee={(deliveryPriceCents || 0) / 100}
          taxRate={preset.taxRate || 0}
        />
      )}
    </div>
  );
};

OrderBasket.propTypes = {
  onCheckoutClick: PropTypes.func,
  buttonWrap: PropTypes.element || PropTypes.nullable,
  removeCheckoutItem: PropTypes.func,
  setCurrentPresetItemFromCheckoutData: PropTypes.func,
  totalPrice: PropTypes.number,
  totalItems: PropTypes.number,
  preset: PropTypes.shape(),
  deliveryPriceCents: PropTypes.number,
  receivingMethod: PropTypes.string,
  checkoutData: PropTypes.arrayOf(PropTypes.shape({})),
};

OrderBasket.defaultProps = {
  onCheckoutClick: () => {},
  removeCheckoutItem: () => {},
  setCurrentPresetItemFromCheckoutData: () => {},
  totalPrice: 0,
  totalItems: 0,
  preset: {},
  deliveryPriceCents: 0,
  checkoutData: [],
  buttonWrap: null,
  receivingMethod: '',
};

export default OrderBasket;
